module.exports = __webpack_public_path__ + "static/img/gwcjs.f82a632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gwcjs.jpg
// module id = MHSi
// module chunks = 4